import axios from "axios";

const apiUrl = "https://mailer-zecon.vercel.app/"

const SendMail = (nome, telefone, email, mensagem) => {
  return axios.post(`${apiUrl}`, { nome, telefone, email, mensagem });
};

export { SendMail };
